import GalleryCardGroup from './components/GalleryCard/GalleryCardGroup/GalleryCardGroup';
import * as React from 'react';
import { styled } from '@mui/system';
import { useEffect, useState } from 'react';
import { useGetNoteGalleryMutation } from '../../store/api/noteApi';
import InfiniteScroll from 'react-infinite-scroll-component';

const GalleryPageContainer = styled('div')(({ theme }) => ({
  padding: '30px',
  width: '100%',

  [theme.breakpoints.down('600')]: {
    padding: '0px',
    width: '100%',
  },
}));

const MaxWidthContainer = styled('div')(({ theme }) => ({
  width: '100%',
}));

const NoteGalleryPage = () => {
  let [pageData, setPageData] = useState({
    list: [],
    hasMore: true,
    pageNum: 0,
  });
  const [getGallery] = useGetNoteGalleryMutation();

  const noteNum = 8;
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async (flag) => {
    flag &&
      setPageData({
        ...pageData,
        pageNum: pageData.pageNum++,
      });

    let { data: note } = await getGallery({ noteNum, pageNum: pageData.pageNum });
    if (note.data.length == 0) {
      // no data
      setPageData({
        ...pageData,
        hasMore: false,
      });
      return;
    }
    if (flag) {
      const list = pageData.list;
      list.push(...note.data);
      setPageData({
        ...pageData,
        list,
      });
    } else {
      setPageData({
        ...pageData,
        list: [...note.data],
      });
    }
  };

  return (
    <MaxWidthContainer>
      <InfiniteScroll
        style={{ width: '100%' }}
        dataLength={pageData.list.length} //This is important field to render the next data
        next={() => {
          fetchData(true);
        }}
        hasMore={pageData.hasMore}
        loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
        endMessage={
          <p style={{ textAlign: 'center' }}>
            <b>Woohoo! You have seen it all </b>
          </p>
        }
        // below props only if you need pull down functionality
        refreshFunction={() => {}}
        pullDownToRefresh
        pullDownToRefreshThreshold={50}
        pullDownToRefreshContent={
          <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
        }
        releaseToRefreshContent={
          <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
        }
      >
        <GalleryPageContainer>
          <GalleryCardGroup galleryCardData={pageData.list} />
        </GalleryPageContainer>
      </InfiniteScroll>
    </MaxWidthContainer>
  );
};

export default NoteGalleryPage;
